import { gql } from '@apollo/client';

const updatePlantOrderMutation = gql`
    mutation updatePlantOrder($email: String!, $order: [Int!]!) {
        update_plant_order_by_pk(pk_columns: { email: $email }, _set: { order: $order }) {
            email
        }
    }
`;

export default updatePlantOrderMutation;
